// extracted by mini-css-extract-plugin
module.exports = {"discountRateContainer":"DiscountRateWrapper_discountRateContainer__YaS18","hightlightedDiscount":"DiscountRateWrapper_hightlightedDiscount__yjAfU"};